import type { FC, SyntheticEvent } from 'react';

import type { ButtonProps } from '@wwe-portal/ui/components/button';
import { Button } from '@wwe-portal/ui/components/button';
import { cn } from '@wwe-portal/ui/lib/lib';
import lockIconWebp from '@wwe-portal/ui/assets/images/flagship/lock-icon.webp';

export interface PurchaseButtonProps
  extends Partial<
    Pick<
      ButtonProps,
      'variant' | 'size' | 'className' | 'style' | 'loading' | 'disabled'
    >
  > {
  price?: React.ReactNode;
  isBlocked?: boolean;
  onClick?: (e: SyntheticEvent) => void;
  children?: React.ReactNode;
}
export const PurchaseButton: FC<PurchaseButtonProps> = ({
  price,
  isBlocked,
  className,
  onClick,
  children,
  ...buttonProps
}) => {
  return (
    <Button
      size="large"
      variant="orange"
      {...buttonProps}
      className={cn(
        'relative border-[1px] border-solid border-white text-white',
        className
      )}
      onClick={onClick}
    >
      {children ?? (
        <>
          <div className="drop-shadow-text-2 flex items-center gap-x-1 font-medium drop-shadow-lg">
            {price}
          </div>
          {Boolean(isBlocked) && (
            <img
              alt="locked"
              className="absolute inset-y-[20%] right-1 h-[21px] md:h-[22px]"
              src={lockIconWebp}
            />
          )}
        </>
      )}
    </Button>
  );
};
